export default {
  path: '/group',
  meta: {
    title: '复活订单',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/group`),
}



// WEBPACK FOOTER //
// ./src/views/Group/router.js